'use client';

import styled, { css } from 'styled-components';

import { Flame } from '@zoomit/icons';
import { Breakpoints, Col, Flex, Link } from '@zoomit/primitives';
import { cssVar, List, ListItem, RedDot, theme, Typography } from '@zoomit/zoomit-ds';

import type { SearchHotContent, SearchSize } from '../../types/search';

type Props = {
  variant?: SearchSize;
  contents: SearchHotContent[];
  onClose?: () => void;
};

export const SearchHotContents = (props: Props) => {
  const { contents, onClose, variant = 'auto' } = props;

  return (
    <ContentWrapper variant={variant}>
      <Col size={2}>
        <Flex flexWrap="nowrap" gap={0.8} spacing={{ mt: 'x' }} alignItems="center">
          <Flame fill={cssVar(theme.primary1)} style={{ flexShrink: 0 }} />
          <Typography variant="subhead-bold">داغ‌ترین‌ها</Typography>
        </Flex>
      </Col>
      <Col>
        <List className="list">
          {contents.map(({ slug, title }, index) => (
            <ListItem onClick={onClose} indicator={<RedDot />} key={index} spacing={{ mb: 'x' }}>
              <Link href={slug} className="**:hover:text-text-hover">
                <Typography variant="callout" lineHeight={2}>
                  {title}
                </Typography>
              </Link>
            </ListItem>
          ))}
        </List>
      </Col>
    </ContentWrapper>
  );
};

const ContentWrapper = styled(Flex)<{ variant: Props['variant'] }>`
  flex-direction: column;
  min-height: 3.2rem;
  gap: 1.6rem;

  .list {
    margin: 0 0.2rem 0 0;
  }

  @media (min-width: ${Breakpoints.md}) {
    ${({ variant }) =>
      variant === 'auto' &&
      css`
        margin-top: 1.6rem;

        flex-direction: row;

        .list {
          margin: 0;
        }
      `}
  }
`;
